export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";

export const GET_PRODUCTS_BY_CATEGORY = "GET_PRODUCTS_BY_CATEGORY";
export const GET_PRODUCTS_BY_CATEGORY_SUCCESS = "GET_PRODUCTS_BY_CATEGORY_SUCCESS";

export const GET_SEARCHED_PRODUCTS = "GET_SEARCHED_PRODUCTS";
export const GET_SEARCHED_PRODUCTS_SUCCESS = "GET_SEARCHED_PRODUCTS_SUCCESS";

export const EDIT_PRODUCT = "EDIT_PRODUCT";
export const EDIT_PRODUCT_SUCCESS = "EDIT_PRODUCT_SUCCESS";

export const CREATE_CATEGORY = "CREATE_CATEGORY";
export const CREATE_CATEGORY_SUCCESS = "CREATE_CATEGORY_SUCCESS";

export const EDIT_CATEGORY = "EDIT_CATEGORY";
export const EDIT_CATEGORY_SUCCESS = "EDIT_CATEGORY_SUCCESS";

export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";

export const GET_PRODUCT_CATALOG = "GET_PRODUCT_CATALOG";
export const GET_PRODUCT_CATALOG_SUCCESS = "GET_PRODUCT_CATALOG_SUCCESS";

export const EDIT_PRODUCT_CATALOG = "EDIT_PRODUCT_CATALOG";
export const EDIT_PRODUCT_CATALOG_SUCCESS = "EDIT_PRODUCT_CATALOG_SUCCESS";

export const UPDATE_PRODUCT_CATALOG = "UPDATE_PRODUCT_CATALOG";
export const UPDATE_PRODUCT_CATALOG_SUCCESS = "UPDATE_PRODUCT_CATALOG_SUCCESS";

export const ADD_PRODUCT_CATALOG = "ADD_PRODUCT_CATALOG";
export const ADD_PRODUCT_CATALOG_SUCCESS = "ADD_PRODUCT_CATALOG_SUCCESS";

export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const ADD_TO_CART = "ADD_TO_CART";

export const PLACE_ORDER = 'PLACE_ORDER';
export const PLACE_ORDER_SUCCESS = 'PLACE_ORDER_SUCCESS';

export const SET_LATEST_ORDER = 'SET_LATEST_ORDER';

export const GET_ORDERS = 'GET_ORDERS';
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS';

export const TOGGLE_TOAST = 'TOGGLE_TOAST';

export const ADD_REMOVE_TO_WISHLIST = 'ADD_REMOVE_TO_WISHLIST';
export const ADD_TO_WISHLIST_SUCCESS = 'ADD_TO_WISHLIST_SUCCESS';

export const OPEN_LOGIN_MODAL = 'OPEN_LOGIN_MODAL';

export const GET_BANNERS = "GET_BANNERS";
export const GET_BANNERS_SUCCESS = "GET_BANNERS_SUCCESS";

export const EMPTY_CART = "EMPTY_CART";

export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const GET_USER_PROFILE_SUCCESS = "GET_USER_PROFILE_SUCCESS";
